const getOrderRequestStatus = (id, orderRequests) => {
  if (!orderRequests) return null
  const orderRequest = orderRequests.filter(req => String(req.id) === id)
  if (!orderRequest[0]) return null
  return orderRequest[0].status
}

export default getOrderRequestStatus
